import React, { CSSProperties, ReactNode } from 'react';
import { useCurrentUser, useRoleOverride } from '../../../App.hooks';
import { UserRoleEnum, DisciplineEnum } from '../../../generated/graphql';
import styles from './ShowOnRole.module.css';

type ShowOnRoleProps = {
    isAdmin: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
    className?: string,
    roles: UserRoleEnum[],
    discipline?: DisciplineEnum | null,
    userId?: string | null,
    hideUserId?: string | null,
};

const ShowOnRole = (props: ShowOnRoleProps) => {
    const { roles, isAdmin, children, userId, discipline, hideUserId } = props;
    const currentUser = useCurrentUser();
    const { isOverrideActive } = useRoleOverride();

    const effectiveIsAdmin = isOverrideActive ? false : isAdmin;
    const visible = effectiveIsAdmin
        || roles.some(r => r === currentUser?.role)
        || (userId != null && userId === currentUser?.id)
        || (discipline != null && currentUser?.discipline === discipline)
        || (hideUserId != null && hideUserId !== currentUser?.id);

    return (
        <>
            {visible && children}
        </>
    );

};

export default ShowOnRole;